import React, { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M16.8 11.7011V6.85714C16.8 5.56071 15.72 4.5 14.4 4.5H2.4C1.08 4.5 0 5.56071 0 6.85714V18.6429C0 19.9393 1.08 21 2.4 21H14.4C15.72 21 16.8 19.9393 16.8 18.6429V14.4589L22.152 17.8179C22.956 18.3129 24 17.7589 24 16.8279V9.34393C24 8.41286 22.956 7.84715 22.152 8.35393L16.8 11.7011ZM13.2 18.6429H3.6C2.94 18.6429 2.4 18.1125 2.4 17.4643V8.03571C2.4 7.3875 2.94 6.85714 3.6 6.85714H13.2C13.86 6.85714 14.4 7.3875 14.4 8.03571V17.4643C14.4 18.1125 13.86 18.6429 13.2 18.6429ZM21.6 14.7182L18.924 13.08L21.6 11.4418C21.6 12.6911 21.6 13.4807 21.6 14.7182Z' />
        </SvgIcon>
    );
});
